import { useSandpack } from '@codesandbox/sandpack-react';

export interface SandboxContextValue {
  /** Currently active file path (e.g. '/App.js') */
  activeFile: string;
  /** Read a file's code content by path */
  getFileCode: (path: string) => string;
  /** Imperatively update a file's content */
  updateFile: (path: string, code: string) => void;
}

/**
 * Hook to access sandbox state — must be used inside a SandboxProvider.
 * This is the single public wrapper around useSandpack() for the rest of the codebase.
 */
export function useSandboxContext(): SandboxContextValue {
  const { sandpack } = useSandpack();

  return {
    activeFile: sandpack.activeFile,
    getFileCode: (path: string) => sandpack.files[path]?.code ?? '',
    updateFile: (path: string, code: string) => sandpack.updateFile(path, code),
  };
}
